import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import OrderCard from "@/components/orders/OrderCard.vue";
import store from "@/store";
import { useRoute } from "vue-router";
import { ref } from "vue";
import { reAuthorize } from "@/services/auth/re-auth";
import ParallelEditErrorModal from "@/components/ParallelEditErrorModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderView',
  setup(__props) {

const order = ref(null);
const orderIndex = ref(0);
reAuthorize(store)
  .then((res) => store.dispatch("OrderStore/getOrders"))
  .then((res) => {
    order.value = store?.state?.OrderStore?.orders.find(
      (order) =>
        order.orderId == route.params.id &&
        order.orderPosition == route.params.position &&
        order.directionType == route.params.direction
    );
    orderIndex.value = store?.state?.OrderStore?.orders.findIndex(
      (order) =>
        order.orderId == route.params.id &&
        order.orderPosition == route.params.position &&
        order.directionType == route.params.direction
    );
  });
const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ParallelEditErrorModal),
    (order.value)
      ? (_openBlock(), _createBlock(OrderCard, {
          key: 0,
          order: order.value,
          index: orderIndex.value,
          activeOrder: orderIndex.value
        }, null, 8, ["order", "index", "activeOrder"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})